module.exports = __webpack_public_path__ + "static/media/button_cancel.5fd9fc45.svg";